import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    storeActions,
    getError,
} from '@src/ducks';

import EmptyPage from '@src/components/layouts/EmptyPage';

import Error401 from './401error';
import Error500 from './500error';

import '../app.scss';

const mapStateToProps = (state) => ({
    errorData: getError(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        ...storeActions,
    }, dispatch),
});

/**
 * ## LoadApp
 *
 * Container of application.
 * Checks if app can load or if it should produce an error page
 *
 * @param {string} process.env.IGNORE_DATABASE_FAILURE Webpack parameter determines if database error should be ignored
 * True: pages will load when 500 error occurs on request
 * False: User gets redirected to 500 error page
 * @param {number} errorData error create from redux error 500 database error on request, or 401 unauthorized
 * Note: The 500 error will appear if you have not imported a Component on a page that you are trying to use
 */
class LoadApp extends Component {
    static propTypes = {
        children: PropTypes.node,
        errorData: PropTypes.object.isRequired,
    };

    render() {
        const {
            children,
            errorData,
        } = this.props;

        if (process.env.IGNORE_DATABASE_FAILURE !== 'true') {
            if (errorData.error || errorData.errorLoaded) {
                return (
                    <EmptyPage>
                        <Error500 />
                    </EmptyPage>
                );
            }
        }

        if (errorData.error === 401) {
            return (
                <EmptyPage>
                    <Error401 />
                </EmptyPage>
            );
        }

        if (errorData.error === 500) {
            return (
                <EmptyPage>
                    <Error500 />
                </EmptyPage>
            );
        }

        return (
            <>
                {React.Children.only(children)}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadApp);
